<p-tabs value="information">
  <p-tablist>
    <p-tab value="information">
      {{ 'common.navigation.information.title' | translateSafe }}
    </p-tab>

    <p-tab value="consumption">
      {{ 'common.navigation.consumption.title' | translateSafe }}
    </p-tab>

    <p-tab value="alarmhistory">
      {{ 'common.navigation.alarm-history.title' | translateSafe }}
    </p-tab>
  </p-tablist>

  <p-tabpanels>
    <p-tabpanel value="information">
      <section class="content">
        <div class="h3 title">
          <span class="material-symbols-rounded">devices</span>
          {{ 'common.fields.device' | translateSafe }}
        </div>

        <div class="row">
          <app-input-text [formData]="serialNumberConfig" />
          <app-input-text [formData]="deviceEuiConfig" />
        </div>

        <div class="row">
          <app-input-text [formData]="lastSigSendConfig" />
        </div>

        <hr class="break-line">

        <div class="h3 title">
          <span class="material-symbols-rounded">map</span>
          {{ 'common.fields.address' | translateSafe }}
        </div>

        <div class="row">
          <app-input-text [formData]="addressConfig" />
        </div>

        <div class="row">
          <app-input-text [formData]="installationDateConfig" />
          <app-dropdown-selector [formData]="installationDistrictConfig" />
        </div>

        <hr class="break-line">

        <div class="h3 title">
          <span class="material-symbols-rounded">construction</span>
          {{ 'common.fields.metadata' | translateSafe }}
        </div>

        <div class="row">
          <app-input-text [formData]="manufacturerConfig" />
          <app-input-text [formData]="modelConfig" />
        </div>

        <app-input-text [formData]="decoderConfig" />

        <app-input-textarea [formData]="commentsConfig" />

        <div class="row small">
          <app-input-select-button [formData]="deviceSizeConfig" />
          <app-input-select-button [formData]="deviceDNConfig" />
        </div>

        <div class="row">
          <app-input-select-button [formData]="deviceRotationConfig" />
        </div>

        <div class="row">
          <app-input-text [formData]="devicePipeTypeConfig" />
          <app-input-text [formData]="deviceRoomConfig" />
        </div>

        <app-image-gallery [imageList]="imageUrls"
                           [showDelete]="false"
                           [readonly]="true" />
      </section>
    </p-tabpanel>

    <p-tabpanel value="consumption">
      <app-device-detail-consumption [device]="device" />
    </p-tabpanel>

    <p-tabpanel value="alarmhistory">
      <app-device-detail-alarm-history [device]="device" />
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>